/* Native Shopify product form for the Horizon storefront. */

(() => {
  const initialise = (root) => {
    if (!root || root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const form = root.querySelector('form.tys-buy-form');
    if (!form) return;
    const demo = root.dataset.demo === 'true';
    const variantData = JSON.parse(root.querySelector('[data-variants]').textContent);
    const variants = Array.isArray(variantData) ? variantData : [];
    const currency = root.dataset.currency || 'EUR';
    const money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency });
    const format = cents => money.formatToParts(cents / 100).filter(part => part.type !== 'literal').map(part => part.value).join('');
    const buy = root.querySelector('[data-main-buy]');
    const feedback = root.querySelector('.purchase-feedback');
    const pickVariant = () => variants.find(variant => String(variant.id) === form.elements.id?.value) || (demo ? { available: false } : null);
    const refresh = () => {
      const variant = pickVariant();
      if (!variant) { buy.disabled = true; return; }
      const quantity = Number(form.elements.quantity.value) || 1;
      const unit = demo ? Number(root.dataset.unitPrice) : variant.price;
      const compare = demo ? Number(root.dataset.comparePrice) : (variant.compare_at_price || 0);
      const discount = count => demo ? Number(root.getAttribute(`data-discount-${count}`) || 0) : 0;
      const total = count => Math.max(0, unit * count - discount(count));
      const regularTotal = count => Math.max(compare, unit) * count;
      const percentOff = count => {
        const regular = regularTotal(count);
        return regular > total(count) ? Math.round((regular - total(count)) * 100 / regular) : 0;
      };
      root.querySelectorAll('[data-compare-price]').forEach(el => { el.textContent = format(regularTotal(quantity)); el.hidden = percentOff(quantity) <= 0; });
      root.querySelectorAll('[data-savings]').forEach(el => { const percent = percentOff(quantity); el.textContent = `${percent}% korting`; el.hidden = percent <= 0; });
      root.querySelectorAll('[data-pack-compare]').forEach(el => {
        const count = Number(el.dataset.packCompare);
        el.textContent = format(regularTotal(count));
        el.hidden = percentOff(count) <= 0;
      });
      root.querySelectorAll('[data-pack-saving]').forEach(el => {
        const count = Number(el.dataset.packSaving);
        const percent = percentOff(count);
        el.textContent = `${percent}% korting`;
        el.hidden = percent <= 0;
      });
      root.querySelectorAll('[data-pack-extra-saving]').forEach(el => {
        const count = Number(el.dataset.packExtraSaving);
        const amount = discount(count);
        el.textContent = `${format(amount)} bundelkorting`;
        el.hidden = amount <= 0;
      });
      root.querySelectorAll('[data-total-price]').forEach(el => { el.textContent = format(total(quantity)); });
      root.querySelectorAll('[data-pack-price]').forEach(el => { el.textContent = format(total(Number(el.dataset.packPrice))); });
      buy.disabled = demo || !variant.available;
      if (!demo) buy.textContent = variant.available ? `In winkelwagen · ${format(total(quantity))}` : 'Uitverkocht';
    };
    const showSlide = index => {
      root.querySelectorAll('[data-slide]').forEach(slide => {
        const active = slide.dataset.slide === String(index);
        slide.hidden = !active; slide.toggleAttribute('data-active', active);
      });
      root.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.thumb === String(index))));
    };
    const selectPreview = index => {
      const input = root.querySelector(`[data-option-index="${index}"]`);
      if (!input) return;
      input.checked = true;
      root.querySelector('[data-selected-option]').textContent = input.value;
      if (input.dataset.colourOnly === 'true') {
        showSlide(index);
        const photo = root.querySelector(`[data-slide="${index}"] .tys-product-photo`);
        if (photo) root.querySelectorAll('[data-option-image]').forEach(image => image.replaceChildren(photo.cloneNode(true)));
        return;
      }
      const photo = input.closest('label').querySelector('.tys-product-photo, img');
      root.querySelectorAll('[data-option-image]').forEach(image => { if (image.tagName === 'IMG' && photo?.tagName === 'IMG') image.src = photo.src; else if (photo) image.replaceChildren(photo.cloneNode(true)); });
      showSlide(index);
    };
    form.addEventListener('change', event => {
      if (event.target.matches('[data-option-index]')) selectPreview(event.target.dataset.optionIndex);
      if (event.target.matches('[data-variant-select]')) {
        const variant = pickVariant();
        const slide = root.querySelector(`[data-media-id="${variant?.featured_image?.id}"]`);
        if (slide) showSlide(slide.dataset.slide);
      }
      refresh();
    });
    root.querySelectorAll('[data-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        if (demo && root.querySelector(`[data-option-index="${button.dataset.thumb}"]`)) { selectPreview(button.dataset.thumb); form.dispatchEvent(new Event('change', { bubbles: true })); return; }
        root.querySelectorAll('[data-slide]').forEach(slide => {
          const active = slide.dataset.slide === button.dataset.thumb;
          slide.hidden = !active; slide.toggleAttribute('data-active', active);
        });
        root.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
      });
    });
    root.querySelectorAll('[data-size-guide]').forEach(link => link.addEventListener('click', () => {
      const guide = root.querySelector(link.getAttribute('href'));
      if (guide) guide.open = true;
    }));
    root.querySelectorAll('.mobile-nav a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
    const sticky = root.querySelector('.stickybuy');
    if (buy && sticky) {
      const updateSticky = () => sticky.toggleAttribute('data-show', buy.getBoundingClientRect().bottom < 0);
      const observer = new IntersectionObserver(updateSticky, { threshold: 0 });
      observer.observe(buy);
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      root._tysObserver = observer;
      root._tysStickyUpdate = updateSticky;
      updateSticky();
    }
    refresh();
  };
  const scan = scope => {
    if (scope.matches?.('[data-tys-product]')) initialise(scope);
    scope.querySelectorAll('[data-tys-product]').forEach(initialise);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  if (!window.tysProductEditorBound) {
    window.tysProductEditorBound = true;
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-tys-product]').forEach(root => {
        root._tysObserver?.disconnect();
        if (root._tysStickyUpdate) {
          window.removeEventListener('scroll', root._tysStickyUpdate);
          window.removeEventListener('resize', root._tysStickyUpdate);
        }
      });
    });
  }
})();




